export default __webpack_public_path__ + "static/media/Group1437.18e81c39.svg";